import React from "react";
import useSetTime from "../../hooks/useSetTime";
export default function Time() {
  return <div className="time">{useSetTime().toLocaleTimeString()}</div>;
}
